import * as React from 'react';

export default function CheckEnter(event, func) {
    if (event.key === "Enter" || event.key === "NumpadEnter") {
        func();
    }
}